import { roleGuarded } from '@/components/shell/RoleState';
import { BusinessTab } from '@/features/settings/BusinessTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/business')({
  staticData: { roles: ['owner'] },
  component: roleGuarded(BusinessTab),
});
